export const NEWS_ITEM_DATA_ATTRIBUTE = 'data-news-item'
export const HEADER_MOBILE_MENU_OPEN_BTN_ATTRIBUTE =
  'data-header-mobile-menu-open-btn'
export const ELEMENT_WIDTH = 'data-width'
export const ELEMENT_HEIGHT = 'data-height'
